// extracted by mini-css-extract-plugin
module.exports = {"ShimmerContainer":"ImageWithLoader_ShimmerContainer__3c6XF","Shimmer":"ImageWithLoader_Shimmer__3QcZr","shimmer":"ImageWithLoader_shimmer__1e-It"};